export default {
    text_1: "Recenzie klientov - DOFFERO®",
    text_2: "Recenzie klientov",
    text_3: "Recenzie tvojich klientov",
    text_4: "Pridaj si recenzie svojich klientov. Tie sa potom môžu zobrazovať v tvojich ponukách, ak si to nastavíš pri tvorbe ponuky.",
    text_5: "Úprava recenzie",
    text_6: "Tvorba recenzie",
    text_7: "Tvoje recenzie",
    text_8: "Klient",
    text_9: "Meno osoby",
    text_10: "Text recenzie",
    text_11: "Uložiť",
    text_12: "Vytvoriť",
    text_13: "Ukončiť",
    text_14: "Recenzia bola vytvorená",
    text_15: "Recenzia bola upravená",
    text_16: "#ID",
    text_17: "Klient",
    text_18: "Osoba",
    text_19: "Text",
    text_20: "Akcie",
    text_21: "Aktivovať",
    text_22: "Deaktivovať",
    text_23: "Upraviť recenziu",
    text_24: "Vymazať recenziu",
    text_25: "Recenzia bola vymazaná",
    text_26: "Recenzia bola deaktivovaná",
    text_27: "Recenzia bola aktivovaná"
}